const USDD = ({ ...props }) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="42" height="42" rx="21" fill="white" />
    <circle
      cx="20.9997"
      cy="21"
      r="19.6"
      fill="#216C58"
      stroke="#216C58"
      stroke-width="0.7"
    />
    <path
      d="M39.1994 21C39.1994 31.0516 31.051 39.2 20.9994 39.2C10.9479 39.2 2.79944 31.0516 2.79944 21C2.79944 10.9484 10.9479 2.8 20.9994 2.8C31.051 2.8 39.1994 10.9484 39.1994 21Z"
      fill="#216C58"
    />
    <rect x="18.5494" y="29.75" width="2.1" height="2.1" fill="#216C58" />
    <rect x="22.0496" y="29.75" width="2.1" height="2.1" fill="#216C58" />
    <rect
      x="14.3491"
      y="8.04996"
      width="14.7"
      height="1.75"
      rx="0.7"
      fill="white"
    />
    <path
      d="M20.9989 10.4999L20.9989 34.2999C20.9989 34.6865 20.6855 34.9999 20.2989 34.9999L19.9489 34.9999C19.5623 34.9999 19.2489 34.6865 19.2489 34.2999L19.2489 10.4999L20.9989 10.4999Z"
      fill="white"
    />
    <path
      d="M23.7994 10.4999L23.7994 34.2999C23.7994 34.6865 23.486 34.9999 23.0994 34.9999L22.7494 34.9999C22.3628 34.9999 22.0494 34.6865 22.0494 34.2999L22.0494 10.4999L23.7994 10.4999Z"
      fill="white"
    />
    <path
      d="M19.506 16.4254L19.506 16.4254L19.5095 16.4241C19.996 16.2461 20.6101 16.1511 21.3616 16.1511C22.4675 16.1511 23.2996 16.3633 23.8913 16.7511C24.3187 17.0313 24.5992 17.3836 24.7508 17.8102C24.9028 18.2379 25.2946 18.6527 25.8444 18.6527H29.0777C29.6514 18.6527 30.17 18.1713 30.0823 17.5437C29.9471 16.5765 29.5818 15.7036 28.9886 14.9308C28.2465 13.964 27.215 13.2202 25.912 12.6909C24.6125 12.1602 23.1041 11.8999 21.3946 11.8999C19.7132 11.8999 18.1993 12.1606 16.8588 12.6895C15.5205 13.2176 14.4502 13.9592 13.6639 14.9226L13.6639 14.9226L13.6629 14.9239C12.8757 15.898 12.4868 17.0395 12.4943 18.3323C12.4869 19.9165 13.0777 21.2006 14.2682 22.1474C15.4248 23.0674 16.9818 23.7286 18.9174 24.1479C18.9178 24.148 18.9182 24.1481 18.9185 24.1482L21.3734 24.697L21.3734 24.697L21.3763 24.6977C22.1877 24.8718 22.8636 25.0635 23.4075 25.2711L23.4089 25.2716C23.9528 25.4765 24.3342 25.7141 24.5794 25.9707L24.5794 25.9707L24.5824 25.9738C24.8161 26.2123 24.9342 26.5022 24.9342 26.8668C24.9342 27.2625 24.8021 27.6089 24.5265 27.9197C24.2453 28.2368 23.8353 28.4994 23.2741 28.6944L23.2729 28.6948C22.724 28.8879 22.0635 28.9889 21.2845 28.9889C20.4938 28.9889 19.7953 28.8822 19.1845 28.6747C18.5876 28.463 18.1247 28.1579 17.7814 27.7666C17.563 27.508 17.4058 27.2058 17.311 26.8551C17.1852 26.3897 16.7799 25.9576 16.2174 25.9576H12.9673C12.3868 25.9576 11.8795 26.4436 11.9511 27.064C12.0884 28.2537 12.4855 29.2895 13.1501 30.1596L13.1518 30.1618C13.9546 31.1957 15.0627 31.9667 16.4582 32.4827L16.4587 32.4829C17.8578 32.9973 19.487 33.2499 21.3395 33.2499C23.2054 33.2499 24.8179 33.001 26.168 32.4917L26.1688 32.4914C27.5226 31.9767 28.5804 31.2464 29.3187 30.2883C30.067 29.3203 30.4415 28.1784 30.4493 26.8787L30.4493 26.8787L30.4493 26.8735C30.4415 25.9898 30.259 25.1921 29.8924 24.4892C29.5378 23.7951 29.0384 23.1946 28.3995 22.6881C27.7667 22.1866 27.0234 21.7683 26.1737 21.4306C25.3296 21.095 24.4061 20.828 23.4046 20.6282L21.3794 20.197L21.3794 20.197L21.3749 20.1961C20.895 20.1005 20.4455 19.9861 20.0262 19.8533C19.6127 19.7159 19.2544 19.5588 18.9487 19.3836C18.6554 19.2092 18.4348 19.0097 18.2769 18.789C18.1417 18.5904 18.0743 18.3535 18.0862 18.0619L18.0865 18.0548V18.0476C18.0865 17.6994 18.1964 17.3922 18.4243 17.1138C18.6609 16.8337 19.0134 16.5996 19.506 16.4254Z"
      fill="white"
      stroke="#216C58"
      stroke-width="0.7"
    />
    <rect x="19.2496" y="15.05" width="1.75" height="2.45" fill="white" />
    <rect x="19.2496" y="23.8" width="1.75" height="2.45" fill="white" />
    <rect x="19.2496" y="31.15" width="1.75" height="2.45" fill="white" />
    <rect x="22.0502" y="15.05" width="1.75" height="2.45" fill="white" />
    <rect x="22.0502" y="23.8" width="1.75" height="2.45" fill="white" />
    <rect x="22.0502" y="31.15" width="1.75" height="2.45" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M38.6133 22.05C38.3352 22.05 38.1059 22.2677 38.0812 22.5448C37.3002 31.2927 29.9508 38.15 20.9998 38.15C12.0488 38.15 4.69938 31.2927 3.91843 22.5448C3.8937 22.2677 3.66445 22.05 3.38629 22.05C3.08409 22.05 2.84339 22.3053 2.86972 22.6063C3.68291 31.9056 11.4895 39.2 20.9998 39.2C30.5101 39.2 38.3167 31.9056 39.1299 22.6063C39.1562 22.3053 38.9155 22.05 38.6133 22.05ZM3.38629 19.95C3.66445 19.95 3.8937 19.7323 3.91843 19.4553C4.69938 10.7074 12.0488 3.85003 20.9998 3.85003C29.9508 3.85003 37.3002 10.7074 38.0812 19.4553C38.1059 19.7323 38.3352 19.95 38.6133 19.95C38.9155 19.95 39.1562 19.6948 39.1299 19.3937C38.3167 10.0945 30.5101 2.80003 20.9998 2.80003C11.4895 2.80003 3.68291 10.0945 2.86972 19.3937C2.84339 19.6948 3.08409 19.95 3.38629 19.95Z"
      fill="white"
    />
  </svg>
);
export default USDD;
